<nav class="navbar navbar-expand-md  fixed-top">
<div class="container axe navbar-brand">
  <img src="../../../assets/logos/IEEE_Tunisia_Section_white.png">
  <img src="../../../assets/logos/logo-white-full.png">
 <div class="links axe">
  <button class="navbar-toggler btn btn-primary" data-toggle="collapse" data-target="#collapsibleNavbar">
    <span >Menu</span>
  </button>
  <div class="collapse navbar-collapse" id="collapsibleNavbar">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a  class="nav-link" [routerLinkActive]="['is-active']" routerLink="/" [routerLinkActiveOptions]="{exact:true}">HOME</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLinkActive]="['is-active']" routerLink="/program" [routerLinkActiveOptions]="{exact:true}"> PROGRAM</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLinkActive]="['is-active']" routerLink="/hackathon" [routerLinkActiveOptions]="{exact:true}">MAKEATHON</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLinkActive]="['is-active']" routerLink="/junior" [routerLinkActiveOptions]="{exact:true}">JUNIOR</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLinkActive]="['is-active']" routerLink="/worshops" [routerLinkActiveOptions]="{exact:true}">WORKSHOPS</a>
      </li>
      <li class="nav-item">
          <a class="nav-link" [routerLinkActive]="['is-active']" routerLink="/forum" [routerLinkActiveOptions]="{exact:true}">FORUM</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLinkActive]="['is-active']" routerLink="/social_activities" [routerLinkActiveOptions]="{exact:true}"> ACTIVITIES</a>
        </li>
  
    </ul>
  </div> 
 </div> 
</div>
  </nav>


 